module.exports = __webpack_public_path__ + "img/charger-speeds-mobile.ed76a7d5.png";